export default "__VITE_ASSET__DPo$rI4H__"